import { useState } from "react";
import type { FC } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { EnvelopeExplanationModal, EnvelopesSummary } from "components";
import { NewAssignmentsModal } from "components/Modal/NewAssignments";

export interface IEnvelopeCounts {
  green: number;
  yellow: number;
  red: number;
  black: number;
}

interface Props {
  data: IEnvelopeCounts | undefined;
}

const DashboardEnvelopesSummary: FC<Props> = ({ data }) => {
  if (data === undefined) return null;

  const { t } = useTranslation(["common"]);

  const [isExplanationModalShown, showExplanationModal] = useState(false);
  const [isAssignmentsModalShown, showAssignmentsModal] = useState(false);

  const showSomething = () => {
    showAssignmentsModal(true);
  };

  const sum = data.green + data.yellow + data.red + data.black;

  return (
    <>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <h4>Moje obálky ({t("assignmentsWithCount", { ns: "common", count: sum })})</h4>
        <Button onClick={showSomething} variant="link" className="py-1">
          Kdy přibudou další úlohy?
        </Button>
      </div>

      <Row>
        <Col>
          <EnvelopesSummary data={data} />
        </Col>
      </Row>

      <EnvelopeExplanationModal
        isShown={isExplanationModalShown}
        onHide={() => {
          showExplanationModal(false);
        }}
      />

      <NewAssignmentsModal
        isShown={isAssignmentsModalShown}
        onHide={() => {
          showAssignmentsModal(false);
        }}
      />
    </>
  );
};

export default DashboardEnvelopesSummary;
